import { render, staticRenderFns } from "./distributionMarket.vue?vue&type=template&id=5445294c&scoped=true"
import script from "./distributionMarket.vue?vue&type=script&lang=js"
export * from "./distributionMarket.vue?vue&type=script&lang=js"
import style0 from "./distributionMarket.vue?vue&type=style&index=0&id=5445294c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445294c",
  null
  
)

export default component.exports